module.exports = __webpack_public_path__ + "static/media/firework-logo-dark.9ebc8788.png";